<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/wnioski-wyslane' aria-label='Wnioski wysłane'>
        Wnioski wysłane
      </a>
    </li>
    <li>
      {{ serviceType()?.name }}
    </li>
  </app-breadcrumbs>
  <section>
    <br>
    <app-alert-container [dismissible]='false'></app-alert-container>
    @if (!loading()) {
      <div class='download-actions' *ngIf='application()'>
        <a href='#' title='Pobierz wniosek PDF' class='btn btn-secondary' (click)='onDownloadApplicationPdf($event)'>
          <i aria-hidden='true' class='fa fa-file-download'></i>
          Pobierz wniosek PDF
        </a>
        @if (!!application()?.rpwNumber) {
          <a href='#' title='Pobierz UPO' class='btn btn-secondary' (click)='onDownloadUPO($event)'>
            <i aria-hidden='true' class='fa fa-download'></i>
            Pobierz UPO
          </a>
        }
        @if (!!application()?.epuapUppAttachment) {
          <a href='#' title='Pobierz UPP' class='btn btn-secondary' (click)='onDownloadUPP($event)'>
            <i aria-hidden='true' class='fa fa-download'></i>
            Pobierz UPP
          </a>
        }
      </div>
      <h2>
        {{ serviceType()?.name }}
      </h2>
      @if (application(); as application) {
        <div class="row">
          <div class="col-md-4">
            <app-label label="Numer pisma:">
              {{ application?.rpwNumber || '-' }}
            </app-label>
          </div>
        </div>
      }
      <app-carrying-out-works-preview
        *ngIf="contentUrl === 'zajecie-pasa-prowadzenie-robot'"
        [application]='application()'>
      </app-carrying-out-works-preview>
      <app-location-reconstruction-of-exit-preview
        *ngIf="contentUrl === 'lokalizacja-przebudowa-zjazdu'"
        [application]='application()'>
      </app-location-reconstruction-of-exit-preview>
      <app-notification-of-emergency-occupation-preview
        *ngIf="contentUrl === 'awaryjne-zajecie-pasa-drogowego'"
        [application]='application()'>
      </app-notification-of-emergency-occupation-preview>
      <app-approval-of-the-exit-design-preview
        *ngIf="contentUrl === 'uzgodnienie-projektu-zjazdu'"
        [application]='application()'>
      </app-approval-of-the-exit-design-preview>
      <app-location-of-devices-unrelated-to-road-preview
        *ngIf="contentUrl === 'umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'"
        [application]='application()'>
      </app-location-of-devices-unrelated-to-road-preview>
      <app-localisation-devices-unrelated-to-road-preview
        *ngIf="contentUrl === 'lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'"
        [application]='application()'>
      </app-localisation-devices-unrelated-to-road-preview>
      <app-approval-of-traffic-organization-projects-preview
        *ngIf="contentUrl === 'zatwierdzenie-projektow-organizacji-ruchu-dla-drog-wewnetrznych'"
        [application]='application()'>
      </app-approval-of-traffic-organization-projects-preview>
      <app-opinion-on-the-project-of-traffic-org-preview
        *ngIf="contentUrl === 'opinia-do-projektu-organizacji-ruchu-dla-drog-publicznych'"
        [application]='application()'>
      </app-opinion-on-the-project-of-traffic-org-preview>
      <app-placement-advertising-preview
        *ngIf="contentUrl === 'umieszczenie-reklamy'"
        [application]='application()'>
      </app-placement-advertising-preview>
      <app-compensation-for-losses-preview
        *ngIf="contentUrl === 'odszkodowanie-za-straty'"
        [application]='application()'>
      </app-compensation-for-losses-preview>
      <app-opinion-on-issuing-a-decision-preview
        *ngIf="contentUrl === 'opinia-w-sprawie-wydania-decyzji'"
        [application]='application()'>
      </app-opinion-on-issuing-a-decision-preview>
      <app-public-information-disclosure-preview
        *ngIf="contentUrl === 'udostepnienie-informacji-publicznej'"
        [application]='application()'>
      </app-public-information-disclosure-preview>
      <app-notification-general-remarks-road-marking-preview
        *ngIf="contentUrl === 'zgloszenie-uwagi-ogolne-oznakowanie-drog'"
        [application]='application()'>
      </app-notification-general-remarks-road-marking-preview>
      <app-documents-information-preview
        *ngIf="contentUrl === 'uzupelnienie-dokumentow'"
        [application]='application()'>
      </app-documents-information-preview>
      <app-general-letter-preview
        *ngIf="contentUrl === 'pismo-ogolne'"
        [application]='application()'>
      </app-general-letter-preview>
      <app-response-to-call-preview
        *ngIf="contentUrl === 'odpowiedz-na-wezwanie'"
        [application]='application()'>
      </app-response-to-call-preview>
      <app-occupation-data-of-lane-placement-construction-objects-preview
        *ngIf="contentUrl === 'zajecie-pasa-umieszczenie-obiektow-budowlanych'"
        [application]='application()'>
      </app-occupation-data-of-lane-placement-construction-objects-preview>
      <app-withdrawal-of-the-application-preview
        *ngIf="contentUrl === 'wycofanie-wniosku'"
        [application]='application()'>
      </app-withdrawal-of-the-application-preview>
      <app-cancellation-of-the-application-preview
        *ngIf="contentUrl === 'odwolanie'"
        [application]='application()'>
      </app-cancellation-of-the-application-preview>
      <app-complaint-of-the-application-preview
        *ngIf="contentUrl === 'zazalenie'"
        [application]='application()'>
      </app-complaint-of-the-application-preview>
      <app-permit-for-oversize-vehicles-preview
        *ngIf="contentUrl === 'zezwolenie-przejazdy-pojazdow-nienormatywnych'"
        [application]='application()'>
      </app-permit-for-oversize-vehicles-preview>
      <app-access-to-public-road-preview
        *ngIf="contentUrl === 'dostep-do-drogi-publicznej'"
        [application]='application()'>
      </app-access-to-public-road-preview>
    }
    <ng-container *ngIf='!loading()'>
      <br>
      <div class='application-actions'>
        <button
          type='button'
          class='btn btn-secondary' routerLink='../../'>
        <span>
          Wróć do listy
        </span>
        </button>
      </div>
    </ng-container>
    <app-spinner *ngIf='loading()'>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  </section>
</app-content>
